import React from "react";
import { ShipmentReconciliationSummaryTile } from "features/shipment-reconciliation/summary-tile/shipmentReconciliationSummaryTile";
import {
  ShipmentReconciliationSummaryTileTypes,
  ShipmentReconciliationSummaryTypes,
} from "app/data/shipment-reconciliation/models";
import { OperationsSummary } from "app/data/dock-scan/models";

interface DockOperationsSummaryTilesProps {
  summary?: OperationsSummary;
  isLoading: boolean;
  isError: boolean;
}

const DockOperationsSummaryTiles: React.FC<DockOperationsSummaryTilesProps> = ({
  summary,
  isLoading,
  isError,
}) => {
  if (isError) {
    return (
      <div className="dock-users__summary dock-users__summary--error">
        Unable to load dock activity summary.
      </div>
    );
  }

  return (
    <div className="dock-users__summary xgs-accessorial-revenue-insights__summary">
      <div className="xgs-accessorial-revenue-insights__summary__row">
        <div className="xgs-accessorial-revenue-insights__summary__row__title">
          Dock Activity
        </div>
        <div className="xgs-accessorial-revenue-insights__summary__row__tiles">
          <ShipmentReconciliationSummaryTile
            tileContentType={ShipmentReconciliationSummaryTileTypes.INFO}
            type={ShipmentReconciliationSummaryTypes.ACCEPTED}
            isLoading={isLoading}
            title="Active Operators"
            value={summary?.activeOperators ?? 0}
            legendDescription="Dock operators with an active equipment assignment at this terminal."
          />
          <ShipmentReconciliationSummaryTile
            tileContentType={ShipmentReconciliationSummaryTileTypes.INFO}
            type={ShipmentReconciliationSummaryTypes.REVENUE}
            isLoading={isLoading}
            title="Scans Today"
            value={summary?.scansToday ?? 0}
            legendDescription={`${summary?.scansTodaySuccess ?? 0} successful · ${summary?.scansTodayFailure ?? 0} failed (UTC calendar day)`}
          />
          <ShipmentReconciliationSummaryTile
            tileContentType={ShipmentReconciliationSummaryTileTypes.INFO}
            type={ShipmentReconciliationSummaryTypes.PENDING_FOR_REVIEW}
            isLoading={isLoading}
            title="Active Workflows"
            value={summary?.activeWorkflows ?? 0}
            legendDescription="In-progress loading workflows on the dock."
          />
          <ShipmentReconciliationSummaryTile
            tileContentType={ShipmentReconciliationSummaryTileTypes.INFO}
            type={ShipmentReconciliationSummaryTypes.AVERAGE}
            isLoading={isLoading}
            title="Logins Today"
            value={summary?.loginsToday ?? 0}
            legendDescription={`${summary?.failedLoginsToday ?? 0} failed login attempts today.`}
          />
        </div>
      </div>
    </div>
  );
};

export default DockOperationsSummaryTiles;
